module.exports = __webpack_public_path__ + "media/images/demo_tests/skyscrapper-724e945f52ae8b9bc0ff6625b0f39410.png";